import React, { FC } from 'react';
import { ProgressScope } from '../../interfaces/api.types';
import { Card, SpanH6 } from '@linkeo.com/ui-lib-react';
import { TargetingForm } from './targeting-form';
import { ActivitiesSelection } from './activities-selection';
import { ContactForm } from './contact-form';
import { ActivityForm } from './activity-form';
import { PaddingForCard } from '../ui/padding-for-card';
import { AIDES_ET_PRIMES } from '../../interfaces/category.types';

interface FormPresentationProps {
  isLoading: boolean;
  noTargeting: boolean;
  onActivitiesSelected: (activities: ProgressScope[]) => void;
  onAnswer: (progress: ProgressScope) => void;
  onFinish: (progress: ProgressScope) => void;
  onPrevious: (() => void) | undefined;
  progress?: ProgressScope;
  uploadApiUrl: string;
  codeBouton: string;
  type?: typeof AIDES_ET_PRIMES | null;
}

export const FormPresentation: FC<FormPresentationProps> = ({
                                                              onAnswer,
                                                              progress,
                                                              onActivitiesSelected,
                                                              onPrevious,
                                                              onFinish,
                                                              isLoading,
                                                              noTargeting,
                                                              uploadApiUrl,
                                                              codeBouton,
                                                              type
                                                            }) => {
  return progress ? <Card style={{ padding: '0' }}>
    <PaddingForCard style={{ textAlign: 'center' }}>
      <h2 style={{ margin: '0' }}>
        <SpanH6 style={{ textTransform: 'uppercase' }}>
          {progress.title}
        </SpanH6>
      </h2>
    </PaddingForCard>
    <hr />
    {
      progress.scope === 'TARGETING' ?
        <TargetingForm
          context={progress}
          onAnswer={onAnswer} />
        : null
    }
    {
      progress.scope === 'ACTIVITY' && progress.categories ?
        <ActivitiesSelection
          noTargeting={noTargeting}
          onPrevious={onPrevious}
          context={progress}
          onActivitiesSelected={onActivitiesSelected} />
        : null
    }
    {
      (progress.scope === 'ACTIVITY' || progress.scope === 'ACTIVITY_QUESTIONS') && progress.activityGroup ?
        <ActivityForm
          codeBouton={codeBouton}
          uploadApiUrl={uploadApiUrl}
          onPrevious={onPrevious}
          context={progress}
          onAnswer={onAnswer} />
        : null
    }
    {
      progress.scope === 'CONTACT' && progress.groups ?
        <ContactForm
          context={progress}
          onAnswer={onFinish}
          isLoading={isLoading}
          type={type}
          onPrevious={onPrevious} />
        : null
    }

  </Card> : null;
};
